import { useEffect,useState } from 'react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { MaterialTableComponent } from '../../../Components/shared/ReusableSmallComponents';
import { StatutsMisionEnum } from '../../../data/Interfaces';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
//import useSideBar from '../../../hooks/useSideBar';
import useUtilities from '../../../hooks/useUtilities';
import { formatDateJJMMYYYY } from '../../../Utils/dateFormatter';
import { getNomPrenomClearFromPersoData, getStatutMissionEnCoursSiDateDebutPasEncoreCommencee, searchLabelInEnumByValue, sortDate } from '../../../Utils/utils';

const InterruptionMissionTraiter = () => {

    const [demandeInterruptionList, setDemandeInterruptionList] = useState();
    const axiosPrivate = useAxiosPrivate();
    const { setBackdropOpen } = useUtilities();
    const [demandesInterruption, setDemandesInterruption] = useState([]);
    const [selectedRow, setSelectedRow] = React.useState(null);
    const { i18n } = useTranslation();

    const columns = [
        { field: 'missionId',
            title: i18n.t('Réf. Mission'),

        },
        {
            field: 'titre',
            title: i18n.t('Intitulé'),

        },
        {
            field: 'demandeur',
            title: i18n.t('Demandeur'),

        },
        {
            field: 'typeDemandeur',
            title: i18n.t('Type Demandeur'),

        },
        {
            field: 'collaboratorId',
            title: i18n.t('Réf. Client'),

            //valueGetter: (params: GridValueGetterParams) =>
            //  `${params.row.firstName || ''} ${params.row.lastName || ''}`,
        },
        {
            field: 'nomClient',
            title: i18n.t('Nom du client'),

            //valueGetter: (params: GridValueGetterParams) =>
            //  `${params.row.firstName || ''} ${params.row.lastName || ''}`,
        },
        {
            field: 'expertId',
            title: i18n.t('Réf. expert'),

            //valueGetter: (params: GridValueGetterParams) =>
            //  `${params.row.firstName || ''} ${params.row.lastName || ''}`,
        },
        {
            field: 'nomExpert',
            title: i18n.t('Nom de l\'expert'),

            //valueGetter: (params: GridValueGetterParams) =>
            //  `${params.row.firstName || ''} ${params.row.lastName || ''}`,
        },
        {
            field: 'dateDemande',
            title: i18n.t('Date de demande'),

            //valueGetter: (params: GridValueGetterParams) =>
            //  `${params.row.firstName || ''} ${params.row.lastName || ''}`,
        },

        {
            field: 'dateDebutMission',
            title: i18n.t('Date début mission'),

        },
        {
            field: 'statutMission',
            title: i18n.t('Statut mission'),
            render: rowData =>
                i18n.t(getStatutMissionEnCoursSiDateDebutPasEncoreCommencee(
                    searchLabelInEnumByValue(StatutsMisionEnum, (rowData?.statutMission)),
                    rowData?.dateDebutMission,
                    rowData?.isInterruptionEnCours
                )),

        },
        {
            field: 'statutInterruptionMission',
            title: i18n.t('Statut demande'),

        },
        {
            field: 'motifInterruption',
            title: i18n.t('Motif d\'interruption'),

        },
        {
            field: 'dateEffective',
            title: i18n.t('Date effective'),

        },

    ];

    useEffect(() => {
        getInterruptionMission();
    },[]);

    useEffect(() => {
        if(demandeInterruptionList){
            let Array1=[];
            console.log('test test',demandeInterruptionList);
            demandeInterruptionList?.forEach(mission => {
                Array1.push({
                    //! mission?.interruptionClient?.isInterrupted ?  will be null, since we must clear the interruption data
                    'id': mission?._id,
                    'missionId': mission?.missionId,
                    'titre': mission?.titre,
                    'demandeur': mission?.interruptionClient?.dateInterruption ? getNomPrenomClearFromPersoData(mission?.interruptionClient?.collaboratorId?.persoData ?? mission?.interruptionClient?.collaboratorEsnId?.persoData) : getNomPrenomClearFromPersoData(mission?.interruptionExpert?.expertId?.persoData ?? mission?.interruptionExpert?.collaboratorEsnId?.persoData),
                    'typeDemandeur':mission?.interruptionClient?.dateInterruption ? 'Client' : 'Expert',
                    'dateDemande':mission?.interruptionClient?.dateInterruption ? formatDateJJMMYYYY(mission?.interruptionClient?.dateInterruption) : formatDateJJMMYYYY(mission?.interruptionExpert?.dateInterruption),
                    'Date':mission?.interruptionClient?.dateInterruption ? mission?.interruptionClient?.dateInterruption : mission?.interruptionExpert?.dateInterruption,
                    'collaboratorId': mission?.companyDataId?.clientId ?? mission?.esnId?.esnId,
                    'nomClient': mission?.companyDataId?.profileEntreprise?.nom ?? mission?.esnId?.profileEntreprise?.nom,
                    'expertId': mission?.expertId?.expertId,
                    'nomExpert': getNomPrenomClearFromPersoData(mission?.expertId?.persoData),
                    'dateEffective':formatDateJJMMYYYY(mission?.interruptionBackOffice?.dateEffective),
                    'dateDebutMission': formatDateJJMMYYYY(mission?.dateDebutMission),
                    'statutMission': mission?.statutMission,
                    'statutInterruptionMission': mission?.interruptionBackOffice?.wasAccepted==true ? 'Acceptée' : 'Rejetée',
                    'isInterruptionEnCours': mission?.interruptionClient?.isInterrupted || mission?.interruptionExpert?.isInterrupted,
                    // 'motifInterruption':mission?.interruptionClient?.isInterrupted ? mission?.interruptionClient?.motifInterruption : mission?.interruptionExpert?.motifInterruption,
                    'motifInterruption': mission?.interruptionBackOffice?.motifAcceptation ?? mission?.interruptionBackOffice?.motifRejet ?? '',
                    //'dateValidationClient':element?.interruptionExpert?.nomExpert,
                });
            });

            setDemandesInterruption(sortDate(Array1));
        }
    },
    [demandeInterruptionList]
    );

    const getInterruptionMission = async () => {
        setBackdropOpen(true);
        try {
            console.log('HELLO FROM the get Missions useEffect');
            const response = await axiosPrivate.get('mission/getDemandesInterruptionMissionTraitees', {
                // signal: controller.signal
            });
            console.log(response.data);
            setDemandeInterruptionList(response.data);
        } catch (error) {
            console.log(error);
        }
        setBackdropOpen(false);
    };

    return (
        <>
            <MaterialTableComponent
                columns={columns}
                title={i18n.t('Demande d\'intteruption traitée')}
                data={demandesInterruption}
                onRowClick={(event, rowData) => {
                    setSelectedRow(rowData?.tableData.id);
                }}
                selectedRow={selectedRow}
                // search={false}
            />
            {/*<div>
                    <ThemeProvider theme={defaultMaterialTheme}>
                        <MaterialTable
                            icons={tableIcons}
                            columns={columns}
                            title="Demande d'intteruption traitée"
                            data={demandesInterruption}
                            options={materialTableOptionsWithoutSearchAndSelection}
                        />

                    </ThemeProvider>
            </div>*/}
        </>
    );
};

export default InterruptionMissionTraiter;